import dayjs from "dayjs";
import {
  getLunarDate,
  getYearCanChi,
  getYearInfo,
  jdn2date,
} from "../../utils/amlich-hnd";
import { useState } from "react";
import { Button, IconButton, MenuItem, Select, Stack, TextField, Tooltip, Typography } from "@mui/material";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { DatePicker, LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";

/**
 * get start date of lunar month
 * @param {dayjs} today
 * @returns [startOfM: dayjs, endOfM: dayjs]
 */

export function getLunarMonthStartEnd(today = dayjs()) {
  const ngayAL = getLunarDate(today.date(), today.month() + 1, today.year());
  const startOfM = today.subtract(ngayAL.day - 1, "d");
  const day2 = startOfM.add(30, "d");
  const ngayAl2 = getLunarDate(day2.date(), day2.month() + 1, day2.year());
  const endOfM = day2.subtract(ngayAl2.day, "d");
  return [startOfM, endOfM];
}
export function getLunarMonthStartEnd2(ngayAL) {
  var y = getYearInfo(ngayAL.year);
  var monthIdx = y.findIndex(
    (m) => m.month === ngayAL.month && m.leap === ngayAL.leap
  );
  var nDays;
  var startAl = y[monthIdx];
  if (monthIdx === y.length - 1) {
    var nexty = getYearInfo(ngayAL.year + 1);
    nDays = nexty[0].jd - y[monthIdx].jd;
  } else {
    nDays = y[monthIdx + 1].jd - y[monthIdx].jd;
  }
  var endAL = { ...startAl, day: nDays, jd: startAl.jd + nDays - 1 };
  return [startAl, endAL];
}
export function LularDatePicker({ setMonth, month }) {
  const [ngayAL, setNgayAL] = useState(
    getLunarDate(month.date(), month.month() + 1, month.year())
  );
  return LularDatePicker2(ngayAL, (ngayAL) => {
    setNgayAL(ngayAL);
    var arr = jdn2date(ngayAL.jd);
    var newMoth = dayjs(arr.reverse().join("-"));
    setMonth(newMoth);
  });
}
/**
 *
 * @param {string} ngayDL YYYY-MM-DD
 * @param {callback} setNgayDL (value: YYYY-MM-DD)
 * @returns
 */
export function LularDayPicker({ ngayDL, setNgayDL, gio, setGio }) {
  var ngay = dayjs(ngayDL);
  var ngayAL = getLunarDate(ngay.date(), ngay.month() + 1, ngay.year());
  return LularDayPicker2(
    ngayAL,
    (ngayAL) => {
      var arr = jdn2date(ngayAL.jd);
      var newDay = dayjs(arr.reverse().join("-"));
      setNgayDL(newDay.format("YYYY-MM-DD"));
    },
    gio,
    setGio
  );
}

export function MonthRangePicker({ from, to, onSearch }) {
  const [startDate, setStartDate] = useState(dayjs(from));
  const [endDate, setEndDate] = useState(dayjs(to));

  const handlePrevMonth = () => {
    console.log("handlePrevMonth, current startDate: ", startDate);
    const base = startDate ?? dayjs();
    const prev = base.subtract(1, "month");
    // setStartDate(prev.startOf("month"));
    // setEndDate(prev.endOf("month"));
    onSearch?.({
      from: prev.startOf("month").format("YYYY-MM-DD"),
      to: prev.endOf("month").format("YYYY-MM-DD"),
    });
  };

  const handleNextMonth = () => {
    console.log("handleNextMonth, current startDate: ", startDate);
    const base = endDate ?? dayjs();
    const next = base.add(1, "month");
    // setStartDate(next.startOf("month"));
    // setEndDate(next.endOf("month"));
    onSearch?.({
      from: next.startOf("month").format("YYYY-MM-DD"),
      to: next.endOf("month").format("YYYY-MM-DD"),
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          p: 1,
          borderRadius: 1,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {/* Prev month */}
        <IconButton
          size="small"
          onClick={handlePrevMonth}
          aria-label="Tháng trước"
        >
          <ChevronLeftIcon />
        </IconButton>

        {/* Start date */}
        <DatePicker
          label="Từ ngày"
          value={startDate}
          onChange={setStartDate}
          format="DD/MM/YYYY" // ✅ dd/MM/yyyy
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              size: "small",
              sx: { width: 150 },
            },
          }}
        />

        {/* End date */}
        <DatePicker
          label="Đến ngày"
          value={endDate}
          onChange={setEndDate}
          format="DD/MM/YYYY" // ✅ dd/MM/yyyy
          minDate={startDate}
          slots={{ textField: TextField }}
          slotProps={{
            textField: {
              size: "small",
              sx: { width: 150 },
            },
          }}
        />

        {/* Search */}
        <Tooltip title="Tìm kiếm">
          <IconButton
            size="small"
            color="primary"
            onClick={() =>
              onSearch?.({
                from: startDate.format("YYYY-MM-DD"),
                to: endDate.format("YYYY-MM-DD"),
              })
            }
          >
            <SearchIcon />
          </IconButton>
        </Tooltip>

        {/* Next month */}
        <IconButton
          size="small"
          onClick={handleNextMonth}
          aria-label="Tháng sau"
        >
          <ChevronRightIcon />
        </IconButton>
      </Stack>
    </LocalizationProvider>
  );
}

export function LularDatePicker2(ngayAL, setNgayAL, gio, setGio) {
  const ly = getYearInfo(ngayAL.year);
  const lst = ly.map((ld, idx) => [idx, ld.month + (ld.leap ? "+" : "")]);
  const curYear = ngayAL.year;

  const curMonthIdx = ly.findIndex(
    (d) => d.month === ngayAL.month && d.leap === ngayAL.leap
  );

  function handleChangeLM(newIdx) {
    var ld;
    if (newIdx < 0) {
      var prevy = getYearInfo(curYear - 1);
      ld = prevy[prevy.length - 1];
    } else if (newIdx >= ly.length) {
      var nexty = getYearInfo(curYear + 1);
      ld = nexty[0];
    } else {
      ld = ly[newIdx];
    }
    setNgayAL(ld);
  }
  return (
    <div style={{ display: "flex" }}>
      <IconButton onClick={() => handleChangeLM(curMonthIdx - 1)}>
        <ArrowBackIosIcon />
      </IconButton>
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction={"row"}
        alignItems="center"
        justifyContent="center"
      >
        <Typography>{"Tháng"}</Typography>
        <Select
          value={curMonthIdx}
          onChange={(e) => handleChangeLM(e.target.value)}
        >
          {lst.map(([idx, text]) => (
            <MenuItem key={idx} value={idx}>
              {text}
            </MenuItem>
          ))}
        </Select>
        <Typography>{getYearCanChi(ngayAL.year)}</Typography>
      </Stack>
      <IconButton onClick={() => handleChangeLM(curMonthIdx + 1)}>
        <ArrowForwardIosIcon />
      </IconButton>
    </div>
  );
}

export function LularDayPicker2(ngayAL, setNgayAL, gio, setGio) {
  console.log("LularDayPicker2");

  const t_ly = getYearInfo(ngayAL.year);
  const t_mLst = t_ly.map((ld, idx) => [idx, ld.month + (ld.leap ? "+" : "")]);
  const t_curMonthIdx = t_ly.findIndex(
    (d) => d.month === ngayAL.month && d.leap === ngayAL.leap
  );
  var nDayOfM;
  if (t_curMonthIdx === t_ly.length - 1) {
    var nextYear = getYearInfo(ngayAL.year + 1);
    nDayOfM = nextYear[0].jd - t_ly[t_curMonthIdx].jd;
  } else {
    nDayOfM = t_ly[t_curMonthIdx + 1].jd - t_ly[t_curMonthIdx].jd;
  }
  const curYear = ngayAL.year;

  function handleChangeLM(newIdx) {
    var ld;
    if (newIdx < 0) {
      var prevy = getYearInfo(curYear - 1);
      ld = prevy[prevy.length - 1];
    } else if (newIdx >= t_ly.length) {
      var nexty = getYearInfo(curYear + 1);
      ld = nexty[0];
    } else {
      ld = t_ly[newIdx];
    }
    setNgayAL(ld);
  }
  function handleChangeLD(day) {
    var newDay = { ...ngayAL, day: day, jd: ngayAL.jd + day - ngayAL.day };
    setNgayAL(newDay);
  }

  return (
    <Stack spacing={{ xs: 1, sm: 2 }} direction={"row"}>
      <IconButton
        onClick={() => handleChangeLM(t_curMonthIdx - 1, t_curMonthIdx)}
      >
        <ArrowBackIosIcon />
      </IconButton>
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction={"row"}
        alignItems="center"
        justifyContent="center"
      >
        <Typography>{"Ngày"}</Typography>
        <Select
          value={ngayAL.day}
          onChange={(e) => handleChangeLD(e.target.value)}
        >
          {Array.from({ length: nDayOfM }, (v, k) => (
            <MenuItem key={k + 1} value={k + 1}>
              {k + 1}
            </MenuItem>
          ))}
        </Select>
        <Typography>{"/"}</Typography>
        <Select
          value={t_curMonthIdx}
          onChange={(e) => handleChangeLM(e.target.value, t_curMonthIdx)}
        >
          {t_mLst.map(([idx, text]) => (
            <MenuItem key={idx} value={idx}>
              {text}
            </MenuItem>
          ))}
        </Select>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimeField
          sx={{ width: "110px" }}
          format="HH:mm:ss"
          value={dayjs("1900-01-01 " + (gio || "00:00:00"))}
          onChange={(newValue) => setGio(newValue.format("hh:mm:ss"))}
        ></TimeField>
      </LocalizationProvider> */}
        <Typography>{getYearCanChi(ngayAL.year)}</Typography>
      </Stack>
      <IconButton
        onClick={() => handleChangeLM(t_curMonthIdx + 1, t_curMonthIdx)}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Stack>
  );
}
